import Icon from 'common/Icon';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
    margin-right: ${2 / 3}em;
`;

export default StyledIcon;
